import { EventEmitter } from 'events';

import { SchemaImpl } from './Schema.js';
import { SchemaField } from './SchemaField.js';
import { Schema, SchemaRule } from './types.js';

export type SchemaRulesEngineEvents<TSchema extends Schema = Schema> = {
  change: [SchemaField<TSchema['fields'][string]>];
};

export class SchemaRulesEngine<
  TSchema extends Schema = Schema,
  TValues extends Record<string, any> = {}
> extends EventEmitter<SchemaRulesEngineEvents> {
  constructor(public schema: SchemaImpl<TSchema, TValues>, public rules: SchemaRule[]) {
    super();

    this.on('change', (field) => {
      this.process('change', field);
    });
  }

  process(eventName: keyof SchemaRulesEngineEvents, field: SchemaField<TSchema['fields'][string]>) {
    const rules = this.rules.filter((rule) => {
      return rule.conditions.some((condition) => {
        return condition.type === eventName && condition.field === field.name.replace('root.', '');
      });
    });

    rules.forEach((rule) => {
      rule.actions.forEach((action) => {
        switch (action.type) {
          case 'set':
            const field = this.schema.get(action.field);

            if (field) {
              field.set('value', action.value);
            }
            break;
        }
      });
    });
  }
}
